export const styles = {
  modal: {
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
      height: '48px',
      padding: 0,
      '& button': {
        margin: '0 12px',
      },
    },

    '& .MuiDialog-paper': {
      width: '650px',
      maxWidth: '650px',
      padding: '0',
      borderRadius: '12px',
      overflow: 'auto',
      backgroundColor: '#fff',
    },
  },

  titleContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: '40px 40px 20px 40px',
    borderBottom: '1px solid #F3F4F9',
  },

  title: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '136%',
    color: '#23252F',
    marginBottom: '4px',
  },

  subtitle: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#6E707A',
  },

  nameContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: '20px 40px 24px 40px',
  },

  itemNameTitle: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#6E707A',
    marginBottom: '0',
  },

  itemName: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '148%',
    color: '#23252F',
  },

  datePickerContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 40px 20px 40px',

    '& .MuiGrid-item': {
      width: '100%',
    },
  },

  successorsContentContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 40px',
  },

  successorsContainer: {
    width: '100%',
    background: '#FAFBFC',
    border: '1px solid #FAFBFC',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '20px',
    padding: '16px',
  },

  successorsTitle: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '148%',
    color: '#6E707A',
  },

  successorsTableContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '12px',
    border: '1px solid #F3F4F9',
    background: '#FFFFFF',
    overflow: 'hidden',
  },

  successorsTableHead: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    borderBottom: '1px solid #F3F4F9',

    '& .tableHeadItem': {
      width: '100%',
      height: '34px',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '7px 16px',
      borderLeft: '1px solid #F3F4F9',
    },

    '& .tableHeadItem:nth-of-type(1)': { borderLeft: 'none', maxWidth: '168px' },

    '& .tableHeadItem:nth-of-type(2)': {
      maxWidth: '175px',
    },

    '& .tableHeadItem:nth-of-type(3)': {
      maxWidth: '160px',
    },

    '& .tableHeadItem:nth-of-type(4)': {
      maxWidth: '175px',
    },

    '& .tableHeadItem:nth-of-type(5)': {
      maxWidth: '42px',
    },
  },

  buttonsContainer: {
    width: '100%',
    padding: '20px 40px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '12px',
  },

  cancelButton: {
    width: '70px',
    background: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #4D6EF5',
    padding: '14px 12px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: '#4D6EF5',
    transition: '300ms',
    textTransform: 'none',

    '&:hover': {
      color: '#FFFFFF',
      background: '#4D6EF5',
      border: '1px solid #4D6EF5',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    },
  },

  saveButton: {
    background: '#4D6EF5',
    borderRadius: '8px',
    border: '1px solid #4D6EF5',
    padding: '14px 18px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: '#FFFFFF',
    transition: '300ms',
    textTransform: 'none',

    '&:hover': { color: '#4D6EF5', background: '#FFFFFF', border: '1px solid #4D6EF5' },
  },
};
